module.exports = __webpack_public_path__ + "img/small-google.847fd15d.svg";